import { getLocalStorage } from "../utils";
import { LOCAL_STORAGE_KEYS, ROLES } from "../constants";
import AdminLayout from "./AdminLayout";
import CustomerLayout from "./CustomerLayout";
import { useSelector } from "react-redux";
import Loader from "../components/Loader";
import { RootState } from "../redux/reducers/allReducers";
import {
  ADMIN_ROUTES,
  AGENT_ROUTES,
  BUILDER_ROUTES,
  SALES_ROUTES,
} from "../constants/appRoutes";
import { useLocation } from "react-router-dom";

const Layout = () => {
  const location = useLocation();
  const { loading } = useSelector((state: RootState) => state.user);

  const isAuthenticated = getLocalStorage(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  const userRole = getLocalStorage(LOCAL_STORAGE_KEYS.USER_ROLE);

  if (
    loading &&
    location.pathname.startsWith(AGENT_ROUTES.ROOT) &&
    location.pathname.startsWith(BUILDER_ROUTES.ROOT) &&
    location.pathname.startsWith(ADMIN_ROUTES.ROOT) &&
    location.pathname.startsWith(SALES_ROUTES.ROOT)
  ) {
    return (
      <div className="flex justify-center mt-10">
        <Loader />
      </div>
    );
  } else if (
    isAuthenticated &&
    (userRole === ROLES.ADMIN || userRole === ROLES.STAFF) &&
    location.pathname.startsWith(ADMIN_ROUTES.ROOT)
  ) {
    return <AdminLayout />;
  } else if (
    isAuthenticated &&
    userRole === ROLES.AGENT &&
    location.pathname.startsWith(AGENT_ROUTES.ROOT)
  ) {
    return <AdminLayout />;
  } else if (
    isAuthenticated &&
    userRole === ROLES.BUILDER &&
    location.pathname.startsWith(BUILDER_ROUTES.ROOT)
  ) {
    return <AdminLayout />;
  } else if (
    isAuthenticated &&
    userRole === ROLES.SALES &&
    location.pathname.startsWith(SALES_ROUTES.ROOT)
  ) {
    return <AdminLayout />;
  } else if (isAuthenticated) {
    return <CustomerLayout />;
  } else {
    return <CustomerLayout />;
  }
};

export default Layout;
